@if (compact) {
  <span class="d-inline-flex align-items-center gap-1 text-nowrap">
    <span class="fw-semibold" [ngClass]="textClass">{{ amount }}</span>
    @if (sign !== 0) {
      <span class="app-badge" [ngClass]="badgeClass" [title]="label">{{ shortLabel }}</span>
    }
  </span>
} @else {
  <div class="d-flex flex-column gap-1">
    <span class="fs-5 fw-bold" [ngClass]="textClass">{{ amount }}</span>
    <span class="app-badge align-self-start" [ngClass]="badgeClass" [title]="label">{{ label }}</span>
  </div>
}
